<template>
    <div class="position-relative mb-11">
        <gofix-card title="Work Findings" class="mb-0" classHeader="mb-2" classContent="mb-0" :class="{'run-loading': Loading}">
            <template slot="gofixCard:right_header">
                <gofix-button v-if="isAllowEditWorkFinding" label=" " class="mr-30" @click="storageItem(null, 'edit')" noBorder>
                    <template slot="gofix:button:beforeLabel">
                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                            <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                        </svg>
                    </template>
                </gofix-button>
            </template>
            <b-row no-gutters class="mb-15">
                <template v-for="(item, index) in WorkFindings">
                    <b-col md="4" class="pr-15  mb-10" :key='index'>
                        <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                            <b-row>
                                <b-col md="9" class="mb-15">
                                    <gofix-text-field label="Description" oneline>
                                        <span v-html="item.description ? item.description.replaceAll('\n', '<br>') : ''"></span>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="3" class="mb-15 text-right">
                                    <span v-if="isAllowEditWorkFinding" class="editBox position-static cursor-pointer mr-12" @click="storageItem(item, 'edit')">
                                        <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                    </span>
                                    <span v-if="isAllowEditWorkFinding" class="editBox position-static cursor-pointer" @click="storageItem(item, 'delete')">
                                        <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                    </span>
                                </b-col>
                                <b-col md="5" class="photosThumb mt-0">
                                    <gofix-text-field label="photos" oneline>
                                        <template v-if="item.attachments">
                                            <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                    <ul class="list-thumb checklist">
                                                        <template v-for="(item, key) in images">
                                                            <li v-if="images.length <= limitImage || key <= ( images.length - ( limitImage + 1) )" :class="{'d-none': key > (limitImage-1)}" v-bind:key="key">
                                                                <img :alt="item.image_file_name" :key="item.url.original" v-auth-image="item.url.original"  src="img/loading.gif">
                                                            </li>
                                                        </template>
                                                    </ul>
                                                    <template v-if="images.length > limitImage">
                                                        <div class="attachmentsColumn cursor-pointer pl-0">
                                                            <div class="item-content bg-transparent pd-0">
                                                                <img class="image-viewer" v-auth-image="images[images.length-1].url.original" src="img/loading.gif">
                                                                <span class="checklist-photo-custom" v-if="images.length > limitImage">+{{ images.length - limitImage }}</span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </viewer-image>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="7">
                                    <gofix-text-field label="Issue Register" oneline>
                                        <router-link v-if="item.issue_register_id" target="_blank" class="text-dark" :to="`/v2/issue-register/${item.issue_register_id}`">
                                           <span class="text-decoration-underline">{{ `Issue.Register.${item.issue_register_id}` }}</span>
                                        </router-link>
                                        <span v-else>--</span>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                    </b-col>
                </template>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Work Findings" hide-footer :centered="true" ref="modal-edit-work-finding" v-model="modal.edit.open">
                <b-form class="pb-10">
                    <gofix-form-input-textarea label="Description" :rows="5" v-model="work_finding.description"></gofix-form-input-textarea>
                    <b-form-group label="photos" class="photosThumb clear-both">
                        <ul class="list-thumb">
                            <li v-for="(item,key) in work_finding.attachments" v-bind:key="key">
                                <img v-auth-image="item.url.thumb" src="img/loading.gif" alt />
                                <span class="delete" @click="deleteImgWorkFinding(item)">
                                    <img src="img/close.png" alt />
                                </span>
                            </li>
                        </ul>
                        <div class="upload-btn-wrapper">
                            <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgWorkFinding" :plain="true" :multiple="true"></b-form-file>
                            <gofix-button class="m-3" label="add photo" outline></gofix-button>
                        </div>
                    </b-form-group>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button v-if="work_finding.id" :disabled="work_finding.issue_register_id ? true : false" @click="deleteItem" label="DELETE" class="mr-3 pull-left" noBorder></gofix-button>
                    <gofix-button label=" "  @click="showPriority" :disabled="work_finding.issue_register_id ? true : false" :loading="isActionIssue" noBorder>
                        <template slot="gofix:button:beforeLabel">SAVE &amp; RAISE<br/>ISSUE</template>
                    </gofix-button>
                    <gofix-button label="SAVE" @click="saveItem(false)" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.delete.open">
                <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="modal.delete.open = false">No</b-button>
                    <b-button class="custom-btn" :disabled="modal.delete.loading" @click="deleteItem"> <b-spinner v-if="modal.delete.loading" small type="grow"></b-spinner> Yes</b-button>
                </b-button-group>
            </b-modal>
            <priority :loading="modal.sla.loading" :service-category-id="modal.sla.service_category_id" @raise-issue="raiseIssue" v-model="modal.sla.open"></priority>
        </gofix-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    const Priority = () => import('./modal_priority.vue')
    import moment from 'moment';
    export default {
        name: 'check-list-work-findings',
        components: {
            ViewerImage,
            Priority
        },
        data() {
            return{
                isAction: false,
                isActionIssue: false,
                limitImage: 2,
                imgWorkFinding: null,
                imgWorkFindingAction: {
                    photos: [],
                    delete: [],
                },
                work_finding_del_ids: [],
                work_finding: {},
                timer: {
                    edit: null,
                    delete: null
                },
                modal: {
                    edit: {
                        open: false,
                        loading: false
                    },
                    delete: {
                        open: false,
                        loading: false
                    },
                    sla: {
                        open: false,
                        loading: false,
                        service_category_id: null
                    },
                }
            }
        },

        computed: {
            ...mapGetters({
                Item: "JobController/Item",
                JobWorkFinding: "JobWorkFindingController/Items",
                Loading: "JobWorkFindingController/Loading",
            }),
            WorkFindings: function() {
                return this.JobWorkFinding.items;
            },
            isAllowEditWorkFinding() {
                if(!this.Item || !this.Item.editing_of_job_data_action || !this.Item.editing_of_job_data_action.is_allow_edit_work_finding) return false;
                return true;
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('resize', this.handleResize);
            })
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            this.handleResize();
            if(this.Item && this.Item.id)
                this.getItems();
        },
        watch: {
            imgWorkFinding(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };

                        this.imgWorkFindingAction.photos.push(file);
                        this.work_finding.attachments.push(data);
                    });
                }
            }
        },
        methods: {
            handleResize() {
                this.limitImage = 2
                if (window.innerWidth < 1920) {
                    this.limitImage = 1
                }
            },
            /* --- Work Finding --- */
            getItems() {
                this.$store
                    .dispatch("JobWorkFindingController/getItems", {
                        isCMS: false,
                        filter: {
                            job_id: this.Item.id
                        },
                    })
                    .then((result) => {
                    });
            },
            storageItem(item, action = null) {
                this.isAction             = false;
                this.isActionIssue     = false;
                this.modal.edit.loading   = false;
                this.modal.delete.loading = false;

                this.work_finding_del_ids = [];
                this.imgWorkFindingAction.photos = [];
                
                if(item) {
                    this.work_finding = JSON.parse(JSON.stringify(item));
                } else {
                    this.work_finding = {
                        job_id: this.Item.id,
                        description:  null,
                        sla_id: null,
                        raise_issue: false,
                        attachments: [],
                    }
                }

                if(action == 'edit'){
                    if(this.work_finding.issue_register_id) {
                        return this.$alertNotification("The entries could not be edited, because the issue register was created.", "warning");
                    }
                    this.modal.edit.open = true;
                }

                if(action == 'delete') {
                    if(this.work_finding.issue_register_id) {
                        return this.$alertNotification("The entries could not be deleted, because the issue register was created.", "warning");
                    }
                    this.modal.delete.open = true;
                }
            },
            showPriority() {
                this.modal.edit.open = false;
                this.modal.sla.service_category_id = this.Item.service_category_id;
                this.modal.sla.open  = true;
            },
            raiseIssue(sla_id) {
                this.work_finding.sla_id = sla_id;
                this.modal.sla.loading   = true;
                this.saveItem(true);
            },
            saveItem(raise_issue = false) {
                if (this.timer.edit) {
                    clearTimeout(this.timer.edit);
                    this.timer.edit = null;
                }
                this.timer.edit = setTimeout(() => {
                    if (
                        !raise_issue && this.isAction ||
                        (raise_issue && this.isActionIssue)
                    ) return;

                    this.isAction = !raise_issue;
                    this.isActionIssue = raise_issue;
                    this.work_finding.raise_issue = raise_issue;
                    this.$store
                        .dispatch("JobWorkFindingController/saveItem", {
                            data:   this.work_finding,
                            photos: this.imgWorkFindingAction.photos
                        })
                        .then((result) => {

                            this.imgWorkFindingAction = {
                                photos: [],
                                delete: [],
                            };

                            if(this.work_finding_del_ids.length > 0) {
                                this.$store.dispatch("JobController/deleteAttachments", { ids : this.work_finding_del_ids, action : 'work_finding' } )
                                .then(result => {
                                  this.work_finding_del_ids = [];
                                })
                            }

                            this.getItems();
                            if(raise_issue) {
                                this.modal.sla.loading  = false;
                                this.modal.sla.open     = false;
                            } else {
                                this.modal.edit.open    = false;
                                this.modal.edit.loading = false;
                            }

                            this.$alertNotification(this.$notificationV2(this.work_finding.id ? "editing" : 'adding', "job_work_finding"));
                        })
                        .catch(error => {
                            this.modal.edit.loading = false;
                            this.modal.sla.loading  = false;
                            this.isAction = false;
                            if(raise_issue) this.modal.sla.open = false;
                            console.log(error);
                        });
                }, 100)
            },
            deleteItem() {
                if(!this.work_finding.id) return;
                if (this.timer.delete) {
                    clearTimeout(this.timer.delete);
                    this.timer.delete = null;
                }
                this.timer.delete = setTimeout(() => {
                    this.modal.delete.loading = true;
                    this.$store.dispatch('JobWorkFindingController/deleteItem', {
                        ids: [this.work_finding.id]
                    })
                    .then(response => {
                        this.modal.delete.open    = false;
                        this.modal.delete.loading = false;
                        this.modal.edit.open      = false;
                        this.getItems();
                        this.$alertNotification(this.$notificationV2('deleting', 'job_work_finding'));
                    })
                    .catch(error => {
                        this.modal.delete.loading = false;
                        console.log(error);
                    });
                }, 100)
            },
            deleteImgWorkFinding(img) {
                if (img.moment) {
                    this.work_finding.attachments = this.work_finding.attachments.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgWorkFindingAction.photos = this.imgWorkFindingAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.work_finding_del_ids.push(img.id);
                    this.work_finding.attachments = this.work_finding.attachments.filter(
                        (item) => item.id != img.id
                    );
                }
            }
        }
    }
</script>
